export type MetricName =
  | 'sessionsRecorded'
  | 'sessionsActive'
  | 'actionsRecorded'
  | 'screenshotsCaptured'
  | 'screenshotsFailed'
  | 'wsConnectionsActive'
  | 'wsConnectionsTotal'
  | 'proxyMessagesForwarded';

export interface MetricSnapshot {
  sessionsRecorded: number;
  sessionsActive: number;
  actionsRecorded: number;
  screenshotsCaptured: number;
  screenshotsFailed: number;
  wsConnectionsActive: number;
  wsConnectionsTotal: number;
  proxyMessagesForwarded: number;
  uptimeSeconds: number;
}

const METRIC_NAMES: MetricName[] = [
  'sessionsRecorded',
  'sessionsActive',
  'actionsRecorded',
  'screenshotsCaptured',
  'screenshotsFailed',
  'wsConnectionsActive',
  'wsConnectionsTotal',
  'proxyMessagesForwarded',
];

export class Metrics {
  private readonly counters: Record<MetricName, number>;
  private readonly startTime: number;

  constructor() {
    this.startTime = Date.now();
    this.counters = {
      sessionsRecorded: 0,
      sessionsActive: 0,
      actionsRecorded: 0,
      screenshotsCaptured: 0,
      screenshotsFailed: 0,
      wsConnectionsActive: 0,
      wsConnectionsTotal: 0,
      proxyMessagesForwarded: 0,
    };
  }

  increment(name: MetricName, by = 1): void {
    this.counters[name] += by;
  }

  decrement(name: MetricName, by = 1): void {
    this.counters[name] = Math.max(0, this.counters[name] - by);
  }

  get(name: MetricName): number {
    return this.counters[name];
  }

  reset(): void {
    for (const key of METRIC_NAMES) {
      this.counters[key] = 0;
    }
  }

  snapshot(): MetricSnapshot {
    return {
      ...this.counters,
      uptimeSeconds: (Date.now() - this.startTime) / 1000,
    };
  }
}

/** Singleton metrics instance shared across all modules. */
export const metrics = new Metrics();
